"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCourseWarning = exports.deleteCourseWarning = exports.addCourseWarning = exports.getCourseWarning = exports.getCourseWarningsByDate = exports.getCourseWarnings = void 0;
const _ = require("lodash");
const getCourseWarnings = async (supabase, course_id) => {
    const { data, error } = await supabase
        .from("course_warnings")
        .select(`*`)
        .eq("course_id", course_id)
        .order("end_date", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getCourseWarnings = getCourseWarnings;
const getCourseWarningsByDate = async (supabase, course_id, date) => {
    const { data, error } = await supabase
        .from("course_warnings")
        .select(`*`)
        .eq("course_id", course_id)
        .lte("start_date", date)
        .gte("end_date", date);
    if (!error)
        return data;
    return error;
};
exports.getCourseWarningsByDate = getCourseWarningsByDate;
const getCourseWarning = async (supabase, id) => {
    const { data, error } = await supabase
        .from("course_warnings")
        .select(`*`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getCourseWarning = getCourseWarning;
const addCourseWarning = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
        updateObj.created_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("course_warnings")
        .insert([updateObj]);
    if (!error)
        return data;
    return error;
};
exports.addCourseWarning = addCourseWarning;
const deleteCourseWarning = async (supabase, id) => {
    const { data, error } = await supabase
        .from("course_warnings")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteCourseWarning = deleteCourseWarning;
const updateCourseWarning = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    updateObj.modified_at = new Date();
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("course_warnings")
        .update(updateObj)
        .eq("id", updateObj.id);
    if (!error)
        return data;
    return error;
};
exports.updateCourseWarning = updateCourseWarning;
